// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"Fieldset_fieldset__FQDyv","legendWrapper":"Fieldset_legendWrapper__GGSZI"};